import { useNavigate } from "react-router-dom";
import { Button, Img, Input, Line, Text } from "components";
import { InputAdornment } from "@mui/material";
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import { setSnackbar } from "../../redux/reducers/snackbar";
import * as CUSTOM from "../../utils/helper/custom";
import * as APIS from "../../utils/helper/Enum";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SubscribeCard from "./subscribeEmailForm";

const Footer = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [disabledBtn, setDisabledBtn] = useState(false);
  
  /**
   * Save Form api
   */
  const saveNewsLatter = async (type = "new") => {
    if (!disabledBtn) {
      dispatch(changeLoader(true));
      try {
        let response = await globalRequest(
          APIS?.PAGES?.NEWSLATTER,
          "post",
          { email: email },
          {},
          true
        );
        response = response?.data;
        if (response?.status == "SUCCESS") {
          setEmail();
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "success",
            })
          );
        } else {
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "error",
            })
          );
        }
      } catch (e) {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: e?.message,
            snackbarState: "error",
          })
        );
      }
      dispatch(changeLoader(false));
    }
  };

  useEffect(() => {
    let status = true;
    if (CUSTOM.isValidField(email, "email")) {
      status = false;
    }
    setDisabledBtn(status);
  }, [email]);

  return (
    <>
      <footer className="flex font-nunitoregular justify-center w-full bg-[#f8f9fc]">
        <div className="flex flex-col items-center justify-center w-full sm:w-full mx-auto bg-[#f8f9fc] rounded-2xl p-5">

          <div className="flex flex-col items-center justify-center w-full">
            <div className="flex flex-row sm:flex-col justify-between w-full mx-auto my-12">
              <div className="flex xs:flex-1 flex-col items-start justify-start w-[40%] sm:w-full">
                <div className="w-full">
                <Img
                  className="w-[132.387px] h-[72px] shrink-0 cursor-pointer"
                  src="/images/logo.svg"
                  alt="rabbitholelogo"
                  onClick={() => navigate("/")}
                />
                </div>
                <div className="text-base text-[#3E4147] font-normal leading-6 font-[Inter] max-w-[80%]">
                  <p className="text-base text-[#3E4147] font-normal leading-6 font-[Inter] mb-6 pt-5">
                    {t("bringsToJoyEveryCelibration")}
                  </p>
                </div>
                <div className="flex flex-row gap-2 w-full">
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.si.rabbitholesa.client" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex w-[120px] h-[40px] justify-center items-center rounded-md"
                  >
                    <Img
                        className="w-auto h-auto sm:h-auto cursor-pointer"
                        src="/images/Group.svg"
                        alt="rabbitholelogo"
                        onClick={() => navigate("/")}
                      />
                  </a>

                  <a 
                    href="https://apps.apple.com/in/app/rabbithole-cakes/id6471412385" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-2 bg-black rounded-md w-auto sm:w-auto lg:w-full justify-start"
                  >
                    <Img
                        className="w-auto h-auto sm:h-auto cursor-pointer"
                        src="/images/appStore.svg"
                        alt="rabbitholelogo"
                        onClick={() => navigate("/")}
                      />

                  </a>

                </div>
              </div>
              <div className="my-2">
                <Text
                  className="text-base text-[#1A1A1A] text-[24px] leading-[32px] my-2 font-medium font-[Unbounded]"
                  size="txtnunitoRegular16Gray700"
                >
                  {t("quicklink")}
                </Text>
                <ul className="grid sm:grid-cols-2 gap-y-4 grid-cols-1 sm:w-[75%] w-full">
                  <li>
                    <Text
                      className="text-[16px] leading-[24px] font-normal text-[#3E4147] !font-[Inter] rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/contactus")}
                    >
                      {t("ourCake")}
                    </Text>
                  </li>
                  <li>
                    <Text
                      className="text-[16px] leading-[24px] font-normal text-[#3E4147] !font-[Inter] rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/blog-list")}
                    >
                      {t("customOrders")}
                    </Text>
                  </li>
                  <li>
                    <Text
                      className="text-[16px] leading-[24px] font-normal text-[#3E4147] !font-[Inter] rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/terms-and-conditions")}
                    >
                      {t("Reservations")}
                    </Text>
                  </li>
                  <li>
                    <Text
                      className="text-[16px] leading-[24px] font-normal text-[#3E4147] !font-[Inter] rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/contactus")}
                    >
                      {t("contactus")}
                    </Text>
                  </li>
                </ul>
              </div>
              <div className="flex sm:justify-between">
                <div className="flex flex-col sm:p-0 p-4">
                  <Text
                    className="text-base text-[#1A1A1A] text-[24px] leading-[32px] font-medium font-bold font-[Unbounded]"
                    size="txtnunitoRegular16Gray700"
                  >
                    {t("Legal")}
                  </Text>
                  <ul className="flex flex-col gap-3 sm:my-4 my-0">
                    <li>
                      <Text
                        className="text-[16px] leading-[24px] font-normal text-[#3E4147] !font-[Inter] rtl:text-right footer-link w-fit"
                        size="txtnunitoMedium16"
                        onClick={() => navigate("/terms-and-conditions")}
                      >
                        {t("termandcondition")} 
                      </Text>
                    </li>
                    <li>
                      <Text
                        className="text-[16px] leading-[24px] font-normal text-[#3E4147] !font-[Inter] rtl:text-right footer-link w-fit"
                        size="txtnunitoMedium16"
                        onClick={() => navigate("/privacy-policy")}
                      >
                        {t("privacyPolicy")}
                      </Text>
                    </li>
                    <li>
                      <Text
                        className="text-[16px] leading-[24px] font-normal text-[#3E4147] !font-[Inter] rtl:text-right footer-link w-fit"
                        size="txtnunitoMedium16"
                        onClick={() => navigate("/return-policy")}
                      >
                        {t("returnPolicy")} 
                      </Text>
                    </li>
                  </ul>
                </div>
                <div className="flex flex-col sm:p-0 p-4">
                  <Text
                    className="text-base text-[#1A1A1A] text-[24px] leading-[32px] font-medium font-bold font-[Unbounded]"
                    size="txtnunitoRegular16Gray700"
                  >
                    {t("Socials")}
                  </Text>
                  <ul className="space-y-3 sm:my-4 my-0">
                    <li>
                      <button
                        onClick={() => { window.open("https://twitter.com/rabbitholesa", '_blank'); }}
                        className="flex items-center gap-2.5 text-sm text-gray-600 hover:text-gray-900 transition-colors group w-full"
                      >
                        <Img
                          className="w-auto h-auto sm:h-auto cursor-pointer"
                          src="/images/twitter.png"
                          alt="rabbitholelogo"
                          onClick={() => navigate("/")}
                        />
                        <span className="text-[16px] leading-[24px] font-normal text-[#3E4147] font-[Inter] rtl:text-right footer-link w-fit">X ({t("twitter")})</span>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => window.open("https://www.instagram.com/rabbitholesa", '_blank')}
                        className="flex items-center gap-2.5 text-sm text-gray-600 hover:text-gray-900 transition-colors group w-full"
                      >
                        <Img
                          className="w-auto h-auto sm:h-auto cursor-pointer"
                          src="/images/insta.png"
                          alt="rabbitholelogo"
                          onClick={() => navigate("/")}
                        />
                        <span className="text-[16px] leading-[24px] font-normal text-[#3E4147] font-[Inter] rtl:text-right footer-link w-fit">{t("instagram")}</span>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => window.open("https://www.tiktok.com/@rabbitholesa", "_blank")}
                        className="flex items-center gap-2.5 text-sm text-gray-600 hover:text-gray-900 transition-colors group w-full"
                      >
                        <Img
                          className="w-auto h-auto sm:h-auto cursor-pointer"
                          src="/images/tictok.png"
                          alt="rabbitholelogo"
                          onClick={() => navigate("/")}
                        />
                        <span className="text-[16px] leading-[24px] font-normal text-[#3E4147] font-[Inter] rtl:text-right footer-link w-fit">{t("tikTok")}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <Line className="w-full h-[1px] bg-gray-300 mt-12" />
            <div className="flex flex-row sm:flex-col justify-between items-center w-full py-4 px-4">
              <Text
                className="
                  text-[#6D737E]
                  font-[Inter]
                  text-base
                  font-normal
                  leading-6
                "
              >
                {t("copyright2025RabbitHoleDotAllRightsReservedDot")}
              </Text>

            <div className="flex flex-row gap-4 mt-2 sm:mt-0">
              <Img
                className="h-[3vh] sm:h-auto w-[50%] cursor-pointer"
                src="/images/Vector.svg"
                alt="rabbitholelogo"
                onClick={() => navigate("/")}
              />
              <Img
                className="h-[3vh] sm:h-auto w-[50%] cursor-pointer"
                src="/images/Encapsulated.svg"
                alt="rabbitholelogo"
                onClick={() => navigate("/")}
              />
              <Img
                className="h-[3vh] sm:h-auto w-[50%] cursor-pointer"
                src="/images/Mastercard.svg"
                alt="rabbitholelogo"
                onClick={() => navigate("/")}
              />
              <Img
                className="h-[3vh] sm:h-auto w-[50%] cursor-pointer"
                src="/images/visa.svg"
                alt="rabbitholelogo"
                onClick={() => navigate("/")}
              />
            </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

Footer.defaultProps = {};

export default Footer;
